<template>
  <vs-table v-if="show" ref="table" :params="params" ></vs-table>
</template>

<script>
  import VsTable from "../../_framework/VsTable.vue";
  export default {
    name: "ActivityType",
    components: {
      VsTable
    },
    data() {
      return {
        access: {},
        show: true,
        params: {
          entity: "ActivityType",
          list: [],
          headers: {
            code: {
              title: "کد فعالیت",
              type: "text"
            },
            CenterTitle: {
              title: "عنوان فعالیت",
              type: "text"
            },
          }
        },

      };
    },

  };
</script>

<style scoped>

</style>
